export type rdsSelection_Dto = {
  id: number;
  eventId: number;
  status: string;
  number: number;
  drawn: number;
  previousState: string;
}

export type rdsSelection_ResponseDto = {
  data: rdsSelection_Dto[];
};

export type rdsSelection_RequestDto = {
  eventId: number;
};

export enum rdsSelectionStatuses {
  NonRunner = 'N',
  Withdrawn = 'W',
  Vacant = 'V',
  Reserve = 'R'
}
